<template>
    <FilterExpandCollapse label="Primary Care Network" :expand="expanded" v-if="showFilter">
      <div class="care-network-clinics">
        <span v-if="showPccInfo">
          <hp5-alert type="info" hide-alert-text inline="inline" :show-alert="true">
            <hp5-semantic size-selection="xs">
              You’ll only get coverage through the <b>{{ myCareNetworkName }}</b> care network
            </hp5-semantic>
          </hp5-alert>
        </span>
        <hp5-label-decorator>
          <label for="care-network"><b>Select a care network</b></label>
          <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        </hp5-label-decorator>
        <select @change="onChangeMethod($event)" id="care-network" v-model="filterContext.careNetworkId">
          <optgroup v-if="myCareNetworkId" label="My care network">
            <option :value="myCareNetworkId">{{ myCareNetworkName }}</option>
          </optgroup>
          <optgroup label="All care networks">
            <option value="">All care networks</option>
          </optgroup>
          <optgroup label="Specific care networks">
            <option v-for="(option, i) of options" :selected="option.value === myCareNetworkId" :key="i" :value="option.value">
              {{ option.label }}
            </option>
          </optgroup>
        </select>
        <span v-if="showPccInfo">
          <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs"></hp5-spacing-vertical>
          <hp5-semantic size-selection="xs">To get coverage through a different care network than <b>{{ myCareNetworkName }}</b>,
            <hp5-link-text-basic size="XS">
              <a target="_blank" href="https://www.healthpartners.com/lp/insurance/members/change-pcc-auth-instructions/"
                >change your primary care clinic.</a>
            </hp5-link-text-basic>
          </hp5-semantic>
          <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        </span>
      </div>
    </FilterExpandCollapse>
</template>

<script setup>

      const model = useFCPModel()
      const { buildCareNetworkClinic } = useFilters(model)
      const { filterContext, careNetworkClinics, plan, profile, context } = model
      const { locationDetailUrl } = useUrls(context.value)
  
      const isPrimaryCare = computed(() => plan.value.isPrimaryCare)
      const showPccInfo = computed(() => profile.value.isAuthenticated && isPrimaryCare.value)
  
      const options = computed(() => {
        let filteredClinics = computed(() => {
          var a = []
          careNetworkClinics.value.forEach((obj) => {
            a.push({ label: obj.name, value: obj.id })
          })
          return a
        })
        return careNetworkClinics.value ? filteredClinics.value : []
      })
  
      const expanded = computed(() => (filterContext.value.gender ? true : false))
      const type = computed(() => filterContext.value.type)
      
      const showFilter = computed(
        () => (type !== 'dentist' || type !== 'dental') && plan.value.primaryCareClinic && plan.value.primaryCareClinic.careNetwork
      )
      const myCareNetworkName = computed(() =>
        plan.value.primaryCareClinic && plan.value.primaryCareClinic.careNetwork ? plan.value.primaryCareClinic.careNetwork.name : ''
      )
      const myCareNetworkId = computed(() =>
        plan.value.primaryCareClinic && plan.value.primaryCareClinic.careNetwork ? plan.value.primaryCareClinic.careNetwork.id : ''
      )
  
      const onChangeMethod = (event) => {
        if (event.target.options.selectedIndex > -1) {
          filterContext.value.careNetworkId = event.target.value
          filterContext.value.careNetworkName = event.target.options[event.target.options.selectedIndex].text
        }
      }

      onMounted(() => { 
        if (filterContext.value.careNetworkId) buildCareNetworkClinic(model.pills.value)
      })

  </script>
  
  <style scoped lang="scss">
  .care-network-clinics {
    select {
      font-family: var(--text-body-font-sm);
      font-weight: var(--text-body-weight-sm);
      font-size: var(--text-body-pixels-sm);
      line-height: var(--text-body-line-height-sm);
      letter-spacing: var(--text-body-letter-spacing-sm);
      font-size: 16px;
      margin: var(--spacing-xxs) 0 0;
      color: var(--color-text-base);
      border: 1px solid var(--color-neutral-base);
      border-radius: 0;
      padding-top: 1px;
      padding-left: calc(1px + var(--spacing-xs));
      padding-right: calc(var(--spacing-xs) + 24px + var(--spacing-xs));
      padding-bottom: 1px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-position: right var(--spacing-xs) top 50%;
      background-repeat: no-repeat;
      background-size: 24px 24px;
      background-color: var(--color-neutral-xxlight);
      width: 100%;
      height: 42px;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkuODggMTEuNDUzIDE2IDE3LjU2bDYuMTItNi4xMDcgMS44OCAxLjg4LTggOC04LTh6IiBmaWxsPSIjNjk2ZTc5Ii8+PC9zdmc+);
    }
  }
  </style>